import { useResponsiveMobile } from "../../../hooks/useResponsiveMobile";
import { CheckRow, MobileCard2 } from "./Section1";

export const Merchant = ({
  refs,
}: {
  refs: {
    payment: React.RefObject<HTMLDivElement>;
    payService: React.RefObject<HTMLDivElement>;
    settle: React.RefObject<HTMLDivElement>;
    merchant: React.RefObject<HTMLDivElement>;
    sales: React.RefObject<HTMLDivElement>;
  };
}) => {
  const isMobile = useResponsiveMobile(900);
  return (
    <div
      id="merchant-mgmt"
      className="flex flex-col gap-[80px] xl:px-0 md:gap-[100px] overflow-y-hidden"
      ref={refs.merchant}
    >
      <div className="flex flex-col gap-[80px] md:gap-14">
        {/* 가맹점 서비스 소개글 */}
        <div className="flex flex-col gap-[32px] md:gap-10">
          <div className="flex flex-col gap-[12px] md:gap-3">
            <h1 className="font-bold md:text-display text-[36px] flex items-center gap-[4px]">
              {isMobile && (
                <img
                  width="48"
                  height="48"
                  alt="가맹점 서비스"
                  src="/assets/images/icon/sidenav_merchant.png"
                />
              )}
              가맹점 서비스
            </h1>
            <span className="text-[18px] md:text-[20px] font-semibold text-[#0079FF]">
              당신의 고객인 가맹점에게, {isMobile && <br />} 운영에 꼭 필요한 기능을 제공합니다
            </span>
          </div>

          {isMobile ? (
            <span className="text-[16px] text-[#4D4F58] leading-relaxed">
              가맹점이 결제를 처리하고, 입금을 확인하고, 상품을 관리하는 과정은 생각보다 복잡합니다.
              품(Poom)은 이런 운영의 번거로움을 줄이기 위해 만들어졌습니다.
              <br />
              <br />
              가맹점은 별도의 개발 없이 결제 내역과 입금 현황을 실시간으로 확인하고,
              수기결제·문자결제·URL결제 등 다양한 결제 방식을 간편하게 이용할 수 있습니다. <br />
              상품 등록과 재고 관리, 세금계산서·현금영수증 발행까지 한 곳 “품”에서 처리 가능합니다.
            </span>
          ) : (
            <span className="text-[12px] md:text-[18px] font-normal text-[#4D4F58] leading-relaxed">
              가맹점이 결제를 처리하고, 입금을 확인하고, 상품을 관리하는 과정은 생각보다 복잡합니다.
              품(Poom)은 이런 운영의 번거로움을 줄이기 위해 만들어졌습니다. 가맹점은 별도의 개발
              없이 결제 내역과 입금 현황을 실시간으로 확인하고, 수기결제·문자결제·URL결제 등 다양한
              결제 방식을 간편하게 이용할 수 있습니다. 상품 등록과 재고 관리, 세금계산서·현금영수증
              발행까지 한 곳 “품”에서 처리 가능합니다.
            </span>
          )}
        </div>

        <div className="flex flex-col gap-6">
          <div className="hidden md:flex flex-row gap-6 items-center">
            <img width={24} height={24} src="/assets/images/icon/all_in_one.png" alt="allinone" />
            <span className="font-normal text-[28px]">올인원 기능 제공</span>
          </div>

          <img
            className="w-auto h-auto"
            src={
              isMobile
                ? "/assets/images/introduction/eg8_mobile.png"
                : "/assets/images/introduction/eg8.png"
            }
            alt="eg"
          />
        </div>
      </div>
      <div className="flex flex-col gap-[24px] md:gap-[80px]">
        <div className="flex flex-col gap-[8px] md:gap-6">
          <h2 className="font-bold text-[#121319] text-[20px] md:text-display2 leading-[1.5]">
            {isMobile ? (
              <>이 모든 기능은 모바일 앱과 웹에서 동시에 제공합니다.</>
            ) : (
              <>
                이 모든 기능은 모바일 앱과 웹에서 동시에 제공되며, <br /> 현장 중심의 빠른 운영을
                지원하고 있습니다.
              </>
            )}
          </h2>
          <span className="font-normal text-[#4D4F58] text-[16px] md:text-heading1_2">
            {isMobile ? (
              <>개발 비용 없이 경쟁력과 신뢰를 함께 높일 수 있습니다.</>
            ) : (
              <>
                파트너사는 가맹점에게 이러한 완성형 서비스를 제공함으로써 개발 비용 없이{" "}
                {!isMobile && <br />} 경쟁력과 신뢰를 함께 높일 수 있습니다.
              </>
            )}
          </span>
        </div>

        {/* 카드 섹션 */}
        <div className="flex flex-col gap-[30px]">
          <div className="md:grid md:grid-cols-[repeat(auto-fit,minmax(330px,1fr))] md:gap-[30px] flex flex-col gap-3">
            <div
              className="flex-1 flex flex-col rounded-[24px] md:h-[394px]"
              style={{
                //  회색 보더(기본 유지)
                boxShadow: "inset 0 0 0 1px #DDE0E6",

                //  그라데이션을 border 영역에만 얹기 위한 세팅
                border: "3px solid transparent",
                backgroundOrigin: "border-box",
                backgroundClip: "padding-box, border-box",

                //  안쪽은 흰색, 바깥(border)은 부분 conic 그라데이션
                backgroundImage: `
      linear-gradient(#ffffff, #ffffff),
      conic-gradient(
        from 270deg,
        #0079FF 60deg,
        #00FF44 100deg,
 
        transparent 90deg,
        transparent 360deg
      )
    `,
              }}
            >
              <div className="flex flex-col py-[32px] px-[24px] items-center justify-start md:px-10 md:py-[60px] md:h-full">
                <div className="flex flex-col gap-6 items-start w-full">
                  <img
                    src="/assets/images/introduction/search.png"
                    alt="icon1"
                    width={56}
                    height={56}
                  />

                  <div className="flex flex-col gap-3 md:gap-5">
                    <span className="md:h-[94px] font-bold text-[18px] md:text-display3_1 ">
                      결제/입금 내역 {!isMobile ? <br /> : ""}
                      실시간 조회
                    </span>
                    <CheckRow
                      content={
                        <span className="font-normal text-[16px] md:text-[18px] text-[#4D4F58] leading-[1.5]">
                          가맹점이 결제 후 입금까지의 흐름을 모바일/웹에서 실시간으로 확인
                        </span>
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            {isMobile ? (
              <MobileCard2
                src="/assets/images/introduction/backup.png"
                text={
                  <>
                    수기결제, 문자결제, URL결제 등 <br />
                    현장 상황에 맞는 유연한 결제 환경 제공
                  </>
                }
                title="다양한 결제방식 지원"
              />
            ) : (
              <div
                className="flex-1 flex flex-col rounded-[24px] h-[394px]"
                style={{
                  //  회색 보더(기본 유지)
                  boxShadow: "inset 0 0 0 1px #DDE0E6",

                  //  그라데이션을 border 영역에만 얹기 위한 세팅
                  border: "3px solid transparent",
                  backgroundOrigin: "border-box",
                  backgroundClip: "padding-box, border-box",

                  //  안쪽은 흰색, 바깥(border)은 부분 conic 그라데이션
                  backgroundImage: `
      linear-gradient(#ffffff, #ffffff),
      conic-gradient(
        from 320deg,
            #FFC300 10deg,
            #00FF44 30deg,
        #0079FF 40deg,
    
        transparent 90deg,
        transparent 360deg
      )
    `,
                }}
              >
                <div className="flex flex-col justify-start px-10 py-[60px] h-full">
                  <div className="flex flex-col gap-6 items-start w-full">
                    <img
                      src="/assets/images/introduction/backup.png"
                      alt="icon1"
                      width={56}
                      height={56}
                    />

                    <div className="flex flex-col gap-5">
                      <span className="h-[94px] font-bold text-[20px] md:text-display3_1 ">
                        다양한 결제 <br />
                        방식 지원
                      </span>
                      <CheckRow
                        content={
                          <span className="font-normal text-[18px] text-[#4D4F58]">
                            수기결제, 문자결제, URL결제 등
                            <br />
                            현장 상황에 맞는 유연한 결제 환경 제공
                          </span>
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {isMobile ? (
              <MobileCard2
                src="/assets/images/introduction/management.png"
                title="상품 등록 및 관리"
                text={
                  <>
                    상품 정보 입력, 가격 설정, 재고 관리 등 <br />
                    판매 운영 기능 포함
                  </>
                }
              />
            ) : (
              <div
                className="flex-1 flex flex-col rounded-[24px] h-[394px]"
                style={{
                  //  회색 보더(기본 유지)
                  boxShadow: "inset 0 0 0 1px #DDE0E6",

                  //  그라데이션을 border 영역에만 얹기 위한 세팅
                  border: "3px solid transparent",
                  backgroundOrigin: "border-box",
                  backgroundClip: "padding-box, border-box",

                  //  안쪽은 흰색, 바깥(border)은 부분 conic 그라데이션
                  backgroundImage: `
      linear-gradient(#ffffff, #ffffff),
      conic-gradient(
        from 360deg,
        #0079FF 0deg,
        #00FF44 90deg,
        #FFC300 110deg,
        transparent 90deg,
        transparent 360deg
      )
    `,
                }}
              >
                <div className="flex flex-col justify-start px-10 py-[60px] h-full">
                  <div className="flex flex-col gap-6 items-start w-full">
                    <img
                      src="/assets/images/introduction/management.png"
                      alt="icon1"
                      width={56}
                      height={56}
                    />

                    <div className="flex flex-col gap-5">
                      <span className="h-[94px] font-bold text-[20px] md:text-display3_1 ">
                        상품 등록 및 관리
                      </span>
                      <CheckRow
                        content={
                          <span className="font-normal text-[18px] text-[#4D4F58]">
                            상품 정보 입력, 가격 설정, 재고 관리 등 판매 운영 기능 포함
                          </span>
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {isMobile ? (
              <MobileCard2
                src="/assets/images/introduction/publication.png"
                title="세금계산서 및 현금영수증 발행"
                text={
                  <>
                    거래에 따른 세금처리 기능을 <br />
                    자동화하여 회계 편의성 제공
                  </>
                }
              />
            ) : (
              <div
                className="flex-1 flex flex-col rounded-[24px] h-[394px]"
                style={{
                  //  회색 보더(기본 유지)
                  boxShadow: "inset 0 0 0 1px #DDE0E6",

                  //  그라데이션을 border 영역에만 얹기 위한 세팅
                  border: "3px solid transparent",
                  backgroundOrigin: "border-box",
                  backgroundClip: "padding-box, border-box",

                  //  안쪽은 흰색, 바깥(border)은 부분 conic 그라데이션
                  backgroundImage: `
      linear-gradient(#ffffff, #ffffff),
      conic-gradient(
        from 180deg,
        #0079FF 30deg,
        #00FF44 90deg,
        #FFC300 110deg,
        transparent 90deg,
        transparent 360deg
      )
    `,
                }}
              >
                <div className="flex flex-col justify-start px-10 py-[60px] h-full">
                  <div className="flex flex-col gap-6 items-start w-full">
                    <img
                      src="/assets/images/introduction/publication.png"
                      alt="icon1"
                      width={56}
                      height={56}
                    />

                    <div className="flex flex-col gap-5">
                      <span className="h-[94px] font-bold text-[20px] md:text-display3_1 ">
                        세금계산서 및 <br />
                        현금영수증 발행
                      </span>
                      <CheckRow
                        content={
                          <span className="font-normal text-[18px] text-[#4D4F58]">
                            거래에 따른 세금처리 기능을 <br />
                            자동화하여 회계 편의성 제공
                          </span>
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {isMobile ? (
              <MobileCard2
                title="모바일 앱 제공"
                src="/assets/images/introduction/app.png"
                text={[
                  <span className="font-normal  md:text-[18px] text-[#4D4F58]">
                    웹과 동일한 기능을 현장에서도 제공
                  </span>,
                  <span className="font-normal md:text-[18px] text-[#4D4F58]">
                    결제, 결제내역/입금내역 조회, <br />
                    상품 관리 기능 제공
                  </span>,
                ]}
              />
            ) : (
              <div
                className="flex-1 flex flex-col rounded-[24px] h-[394px]"
                style={{
                  //  회색 보더(기본 유지)
                  boxShadow: "inset 0 0 0 1px #DDE0E6",

                  //  그라데이션을 border 영역에만 얹기 위한 세팅
                  border: "3px solid transparent",
                  backgroundOrigin: "border-box",
                  backgroundClip: "padding-box, border-box",

                  //  안쪽은 흰색, 바깥(border)은 부분 conic 그라데이션
                  backgroundImage: `
      linear-gradient(#ffffff, #ffffff),
    conic-gradient(
  from 140deg,

  #0079FF 1deg 15deg,
  #00FF44 25deg 60deg,
  #FFC300 65deg 75deg,

  transparent 38deg 360deg
)
    `,
                }}
              >
                <div className="flex flex-col justify-start px-10 py-[60px] h-full">
                  <div className="flex flex-col gap-6 items-start w-full">
                    <img
                      src="/assets/images/introduction/app.png"
                      alt="icon1"
                      width={56}
                      height={56}
                    />

                    <div className="flex flex-col gap-5">
                      <span className="h-[94px] font-bold text-[20px] md:text-display3_1 ">
                        모바일 앱 <br /> 제공
                      </span>
                      <CheckRow
                        content={[
                          <span className="font-normal text-[18px] text-[#4D4F58]">
                            웹과 동일한 기능을 현장에서도 제공
                          </span>,
                          <span className="font-normal text-[18px] text-[#4D4F58]">
                            결제, 결제내역/입금내역 조회, <br />
                            상품 관리 기능 제공
                          </span>,
                        ]}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {isMobile ? (
              <div
                className="flex-1 flex flex-col rounded-[24px] md:h-[394px]"
                style={{
                  //  회색 보더(기본 유지)
                  boxShadow: "inset 0 0 0 1px #DDE0E6",

                  //  그라데이션을 border 영역에만 얹기 위한 세팅
                  border: "3px solid transparent",
                  backgroundOrigin: "border-box",
                  backgroundClip: "padding-box, border-box",

                  //  안쪽은 흰색, 바깥(border)은 부분 conic 그라데이션
                  backgroundImage: `
      linear-gradient(#ffffff, #ffffff),
      conic-gradient(
        from 90deg,
        #00FF44 1deg,
         #0079FF 90deg,
 
        transparent 10deg,
        transparent 360deg
      )
    `,
                }}
              >
                <div className="flex flex-col p-6 items-center justify-start md:p-10 md:h-full">
                  <div className="flex flex-col gap-6 items-start w-full">
                    <img
                      src="/assets/images/introduction/service.png"
                      alt="icon1"
                      width={56}
                      height={56}
                    />

                    <div className="flex flex-col gap-3 md:gap-5">
                      <span className="md:h-[94px] font-bold text-[18px] md:text-display3_1 ">
                        SaaS 기반 서비스 제공
                      </span>
                      <CheckRow
                        content={
                          <span className="font-normal text-[16px] md:text-[18px] text-[#4D4F58] leading-[1.5]">
                            별도 개발 없이 품을 통해 <br />
                            모든 기능을 즉시 제공 가능
                          </span>
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div
                className="flex-1 flex flex-col rounded-[24px] h-[394px]"
                style={{
                  //  회색 보더(기본 유지)
                  boxShadow: "inset 0 0 0 1px #DDE0E6",

                  //  그라데이션을 border 영역에만 얹기 위한 세팅
                  border: "3px solid transparent",
                  backgroundOrigin: "border-box",
                  backgroundClip: "padding-box, border-box",

                  //  안쪽은 흰색, 바깥(border)은 부분 conic 그라데이션
                  backgroundImage: `
      linear-gradient(#ffffff, #ffffff),
      conic-gradient(
        from 90deg,
        #0079FF 60deg,
        #00FF44 100deg,
        #FFC300 110deg,
        transparent 90deg,
        transparent 360deg
      )
    `,
                }}
              >
                <div className="flex flex-col justify-start px-10 py-[60px] h-full">
                  <div className="flex flex-col gap-6 items-start w-full">
                    <img
                      src="/assets/images/introduction/service.png"
                      alt="icon1"
                      width={56}
                      height={56}
                    />

                    <div className="flex flex-col gap-5">
                      <span className="h-[94px] font-bold text-[20px] md:text-display3_1 ">
                        SaaS 기반 <br />
                        서비스 제공
                      </span>
                      <CheckRow
                        content={
                          <span className="font-normal text-[18px] text-[#4D4F58]">
                            별도 개발 없이 품을 통해
                            <br />
                            모든 기능을 즉시 제공 가능
                          </span>
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
